import '@gjensidige/builders-components/style.css';
import '@gjensidige/builders-fonts/fonts.css';
import '@gjensidige/nci-core-global-css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Flex } from '@gjensidige/builders-components';
import { clientIdentification } from '@gjensidige/service-client-identification';

import App from './App';

clientIdentification.configure({
  clientId: process.env.REACT_APP_NAME,
  clientVersion: process.env.REACT_APP_VERSION,
});

const container = document.getElementById('claims-openpages-forms-frontend');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Flex center>
      <div style={{ width: '930px' }}>
        <App />
      </div>
    </Flex>
  </React.StrictMode>,
);
